import React from 'react';
import {Icon} from "@chakra-ui/react";

const QuotaIcon = (props) => (
    <Icon xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" strokeWidth="2" stroke="#2c3e50" fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 3v5m4 4h5"/>
        <path d="M8.929 14.582l-3.429 2.918"/>
        <circle cx="12" cy="12" r="4"/>
        <circle cx="12" cy="12" r="9"/>
    </Icon>
)

export default QuotaIcon;